/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import Cookies from 'js-cookie';
import { authenticationAPI } from '../api/auth';
import { removeAuthentication } from '../auth-helper';
import useModalStore from '../stores/use-modal.store';
import { generateUUID, isEmpty } from '../utils';
import { showGlobalAlert } from './alert';

let contentType = null as any;
let requestId = null as null | string;

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers = {
    ...config.headers,
    ...(Cookies.get('authToken')
      ? { 'X-Authorization': `Bearer ${Cookies.get('authToken')}` }
      : {}),
  };
  contentType = config.headers['Content-Type'];

  if (config.withRequestId) {
    requestId = requestId || generateUUID();
    config.headers = {
      ...config.headers,
      'X-Request-Id': requestId,
    };
  } else {
    requestId = null;
  }

  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  requestId = null;
  return response;
};

let refreshTokenPromise = null as any;
const clearPromise = () => (refreshTokenPromise = null);

const onResponseError = async (
  error: AxiosError,
  axiosInstance: AxiosInstance
): Promise<AxiosError> => {
  // reset requestId if aboarted request
  if (error.code === 'ECONNABORTED') {
    requestId = null;
  }

  const originalRequest = error.config;
  const errorDataMessage = error as {
    response: { data: { message: string; data: any } };
    config: { data: any };
  };

  if (
    error.response?.status === 401 &&
    //@ts-ignore
    !originalRequest._retry &&
    //@ts-ignore
    !originalRequest.url?.includes('api/auth/refresh-token')
  ) {
    //@ts-ignore
    originalRequest._retry = true;
    if (Cookies.get('refreshToken')) {
      if (!refreshTokenPromise) {
        refreshTokenPromise = authenticationAPI({
          domainApp: axiosInstance.defaults.data['domain-app'] as string,
          authUrl: axiosInstance.defaults.data['auth-url'] as string,
        })
          .refreshToken()
          .finally(clearPromise);
      }

      const resp = await refreshTokenPromise;
      if (resp.authToken) {
        Cookies.set('authToken', resp.authToken, {
          domain: axiosInstance.defaults.data['domain-app'],
        });
        Cookies.set('refreshToken', resp.refreshToken, {
          domain: axiosInstance.defaults.data['domain-app'],
        });
        axiosInstance.defaults.headers.common['X-Authorization'] =
          'Bearer ' + resp.authToken;
        //@ts-ignore
        originalRequest.headers['Content-Type'] = contentType;
        //@ts-ignore
        return axiosInstance(originalRequest);
      } else {
        removeAuthentication(
          axiosInstance.defaults.data['domain-app'] as string
        );

        const currentUrl =
          window.location.pathname +
          window.location.search +
          window.location.hash;
        window.location.href = `${
          axiosInstance.defaults.data['auth-url'] || '/'
        }?redirect=${encodeURIComponent(currentUrl)}`;
      }
    } else {
      removeAuthentication(axiosInstance.defaults.data['domain-app'] as string);
      const currentUrl =
        window.location.pathname +
        window.location.search +
        window.location.hash;

      window.location.href = `${
        axiosInstance.defaults.data['auth-url'] || '/'
      }?redirect=${encodeURIComponent(currentUrl)}`;
    }
  } else if (
    error.response?.status &&
    error.response?.status >= 500 &&
    //@ts-ignore
    !error.response?.data?.errorCode
  ) {
    const isApiNotEligibleShowAlert =
      error.response.config.url?.includes('api/sitemap.xml') ||
      error.response.config.url?.includes('api/wp') ||
      window?.location?.pathname?.includes('/order');
    if (!isApiNotEligibleShowAlert) {
      showGlobalAlert('error_maintenance');
    }
  } else if (error.response?.status === 400) {
    console.log('error request ', error);
    if (
      errorDataMessage.response?.data?.message ===
        'ERR_SUBSCRIPTION_NOT_ACTIVE_UNAUTHORIZED_ACCESS' &&
      !isEmpty(errorDataMessage.config?.data)
    ) {
      const modalStore = useModalStore;
      const modalData = modalStore.getState();
      modalStore.setState({
        modalData: {
          ...modalData,
          errorMessage: {
            title: 'modal_subscription_finished.title',
            infoTitle: 'modal_subscription_finished.info_title',
            infoMessage: 'modal_subscription_finished.info_message',
            description: 'modal_subscription_finished.description',
          },
        },
        modalName: 'modalSubscriptionFinished',
      });
    }
  }
  return Promise.reject(error);
};

export function setupInterceptorsTo(
  axiosInstance: AxiosInstance
): AxiosInstance {
  //@ts-ignore
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, (err) =>
    onResponseError(err, axiosInstance)
  );
  return axiosInstance;
}
